<template>
    <div class="suscription-v3-container">
        <div class="ppv2-flex ppv2-items-center ppv2-justify-between">
            <h2 class="poppinsRegular !ppv2-text-white ppv2-mb-[18px]" :style="{ fontSize: normalizeFontSize(26) }">
                {{ $t('subscription.manage.title') }}
            </h2>
        </div>
        <!-- Management Cards -->
        <div class="cardManagement ppv2-grid ppv2-grid-cols-1 lg:ppv2-grid-cols-2" :style="{ marginBottom: '20px', gap: '2%' }">
            <!-- Current Offer Card -->
            <div
                class="ppv2-shadow-[0px_10.72px_42.89px_0px_#0000000F] ppv2-bg-[url('/media/abonnement/bgCardAbonnement.png')] ppv2-bg-cover ppv2-bg-center ppv2-relative ppv2-py-4 ppv2-rounded-[16px] ppv2-flex ppv2-flex-col ppv2-justify-between ppv2-overflow-hidden"
            >
                <div>
                    <div class="ppv2-mb-2 ppv2-flex ppv2-items-center ppv2-gap-3 ppv2-px-6">
                        <span
                            class="ppv2-text-[#fff] ppv2-opacity-70 poppinsSemiBold ppv2-text-[10px] ppv2-uppercase tracking-wider"
                        >
                            {{ $t('subscription.manage.current_offer') }}
                        </span>
                        <span
                            v-if="isOnTrial"
                            class="poppinsMedium ppv2-rounded-full ppv2-px-3 ppv2-py-1 ppv2-text-[11px] ppv2-uppercase ppv2-tracking-wider ppv2-bg-white/15 ppv2-text-white ppv2-border ppv2-border-white/30"
                        >
                            {{ $t('subscription.manage.trial') + ' — ' + trialEndsLabel }}
                        </span>
                    </div>

                    <div class="ppv2-flex ppv2-justify-between ppv2-items-start ppv2-mb-4 ppv2-px-6">
                        <h2 class="poppinsBold ppv2-text-white ppv2-mb-0" :style="{ fontSize: normalizeFontSize(30) }">
                            {{ $t('subscription.plans.' + currentPlanKey + '.name') }}
                        </h2>
                        <div class="ppv2-text-right ppv2-flex ppv2-items-end ppv2-gap-1">
                            <span class="poppinsBold ppv2-text-white" :style="{ fontSize: normalizeFontSize(26) }">
                                {{ $t('subscription.common.' + currentPlanKey + '_price') }}
                            </span>
                            <div
                                class="poppinsMedium ppv2-text-white/80 ppv2-relative ppv2-top-[-4px]"
                                :style="{ fontSize: normalizeFontSize(12) }"
                            >
                                {{ $t('subscription.common.monthly_ht') }}
                            </div>
                        </div>
                    </div>

                    <div class="ppv2-flex ppv2-pb-3 ppv2-pt-0 ppv2-px-6" :style="{ gap: normalizeSize(48, true) }">
                        <div>
                            <div
                                class="ppv2-opacity-70 ppv2-text-white poppinsSemiBold ppv2-text-[10px] ppv2-uppercase tracking-wider ppv2-mb-2"
                            >
                                {{ $t('subscription.manage.active_since') }}
                            </div>
                            <div class="poppinsSemiBold ppv2-text-white" :style="{ fontSize: normalizeFontSize(14) }">
                                {{ subscriptionStartDate }}
                            </div>
                        </div>
                        <div>
                            <div
                                class="ppv2-opacity-70 ppv2-text-white poppinsSemiBold ppv2-text-[10px] ppv2-uppercase tracking-wider ppv2-mb-2"
                            >
                                {{ $t('subscription.manage.status') }}
                            </div>
                            <div
                                class="poppinsSemiBold ppv2-text-white ppv2-capitalize"
                                :style="{ fontSize: normalizeFontSize(14) }"
                            >
                                {{ displayStatus }}
                            </div>
                        </div>
                        <div>
                            <div
                                class="ppv2-opacity-70 ppv2-text-white poppinsSemiBold ppv2-text-[10px] ppv2-uppercase tracking-wider ppv2-mb-2"
                            >
                                {{ $t('subscription.manage.billing') }}
                            </div>
                            <div class="poppinsSemiBold ppv2-text-white" :style="{ fontSize: normalizeFontSize(14) }">
                                {{ $t('subscription.manage.monthly') }}
                            </div>
                        </div>
                    </div>
                    <div class="ppv2-border-b ppv2-border-white/20"></div>
                </div>

                <div
                    class="ppv2-flex ppv2-px-6"
                    :style="{ gap: normalizeSize(16, true), marginTop: normalizeSizeVertical(16, true) }"
                >
                    <button
                        @click="handlePortalRedirect"
                        :disabled="isLoading"
                        class="poppinsSemiBold ppv2-h-[38px] ppv2-max-h-[38px] ppv2-min-w-[126px] ppv2-flex ppv2-items-center ppv2-justify-center !ppv2-text-white hover:ppv2-text-white ppv2-gap-3 ppv2-px-4 ppv2-py-2 ppv2-rounded-[9px] ppv2-bg-[#7D2DBD] ppv2-text-white hover:ppv2-bg-[#6b26a3] ppv2-transition-all ppv2-shadow-lg"
                        :style="{ fontSize: normalizeFontSize(13.5), boxShadow: '0px 2.68px 16.08px 0px #6C3DE84D' }"
                    >
                        <CreditCard :size="16" />
                        {{ $t('subscription.manage.manage') }}
                    </button>
                    <button
                        @click="goToPricing"
                        :disabled="isLoading"
                        class="poppinsSemiBold ppv2-h-[38px] ppv2-max-h-[38px] ppv2-min-w-[150px] ppv2-flex ppv2-items-center ppv2-justify-center ppv2-px-4 ppv2-py-2 ppv2-rounded-[9px] ppv2-bg-[#fff] ppv2-text-[#000] poppinsSemiBold ppv2-transition-all hover:ppv2-bg-white/90"
                        :style="{ fontSize: normalizeFontSize(13.5) }"
                    >
                        {{ $t('subscription.manage.change_plan') }}
                    </button>
                </div>
            </div>

            <!-- Invoices Card -->
            <div
                class="ppv2-rounded-[16px] ppv2-bg-white dark:ppv2-bg-dark ppv2-flex ppv2-flex-col ppv2-justify-between ppv2-shadow-[0px_4px_24px_rgba(0,0,0,0.04)] ppv2-gap-4"
            >
                <h3
                    class="poppinsBold ppv2-text-black ppv2-mb-0 ppv2-px-6 ppv2-pt-4 ppv2-pb-2 ppv2-border-b ppv2-border-black ppv2-border-opacity-[7%]"
                    :style="{ fontSize: normalizeFontSize(19) }"
                >
                    {{ $t('subscription.manage.invoices') }}
                </h3>

                <div class="ppv2-flex ppv2-gap-4 ppv2-items-center ppv2-px-6">
                    <div class="ppv2-flex-shrink-0 ppv2-flex ppv2-items-center ppv2-justify-center">
                        <img src="/media/abonnement/stripe.png" width="36px" height="36px" alt="stripe" />
                    </div>
                    <div>
                        <h4 class="poppinsMedium ppv2-text-black ppv2-mb-2" :style="{ fontSize: normalizeFontSize(18) }">
                            {{ $t('subscription.manage.stripe_portal_title') }}
                        </h4>
                        <p
                            class="poppinsRegular ppv2-text-muted ppv2-leading-relaxed !ppv2-mb-0"
                            :style="{ fontSize: normalizeFontSize(12.5), flex: '1 1 220px', minWidth: '200px' }"
                        >
                            {{ $t('subscription.manage.stripe_portal_desc') }}
                        </p>
                    </div>
                </div>
                <div class="ppv2-border-t ppv2-border-black ppv2-border-opacity-[7%] ppv2-px-6 ppv2-py-4">
                    <button
                        @click="handlePortalRedirect"
                        :disabled="isLoading"
                        class="ppv2-w-fit ppv2-h-[38px] ppv2-max-h-[38px] ppv2-px-4 ppv2-py-3 ppv2-rounded-xl ppv2-bg-[#635bff] hover:ppv2-bg-[#4f47e0] ppv2-text-white poppinsSemiBold ppv2-flex ppv2-items-center ppv2-justify-center ppv2-gap-3 ppv2-transition-all hover:ppv2-opacity-90"
                        :style="{ fontSize: normalizeFontSize(13.5), boxShadow: '0px 2.68px 16.08px 0px #6C3DE84D' }"
                    >
                        {{ $t('subscription.manage.access_invoices') }}
                        <ArrowRight :size="16" />
                    </button>
                </div>
            </div>
        </div>

        <div class="ppv2-bg-white dark:ppv2-bg-dark ppv2-rounded-3xl ppv2-p-6">
            <div class="ppv2-relative ppv2-z-10 ppv2-px-2 ppv2-pb-16 ppv2-overflow-visible">
                <!-- Pricing Comparison Table -->
                <SubscriptionTable
                    :current-plan-key="currentPlanKey"
                    :is-manage-page="true"
                    :is-canceling="isCanceling"
                    @plan-click="handlePlanSelection"
                    @cancel-click="handleCancelSubscription"
                    @resume-click="resumeSubscription"
                />

                <!-- FAQ Section -->
                <SubscriptionFaq />
            </div>
        </div>

        <confirmation-dialog
            :is-open="showCancelDialog"
            type="danger"
            :title="$t('subscription.manage.cancel_confirm_title')"
            :message="$t('subscription.manage.cancel_confirm_text')"
            :confirm-text="$t('common.yes_cancel')"
            :cancel-text="$t('common.no_keep')"
            @confirm="confirmCancelSubscription"
            @cancel="showCancelDialog = false"
        />
    </div>
</template>

<script>
import normalizeSize from '../../utils/normalizeSize'
import normalizeSizeVertical from '../../utils/normalizeSizeVertical'
import axios from 'axios'
import SubscriptionTable from './SubscriptionTable.vue'
import SubscriptionFaq from './SubscriptionFaq.vue'
import { CreditCard, ArrowRight } from 'lucide-vue'
import normalizeFontSize from '../../utils/normalizeFontSize'

export default {
    name: 'ManageSubscriptionPage',
    props: {
        currentPlanKey: {
            type: String,
            default: 'free',
        },
        tenant: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        tenantId: {
            type: String,
            required: false,
            default: '',
        },
        centralDomain: {
            type: String,
            required: true,
        },
        billingTokens: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        isOnTrial: {
            type: Boolean,
            default: false,
        },
        trialEndsAt: {
            type: String,
            default: '',
        },
    },
    components: {
        SubscriptionTable,
        SubscriptionFaq,
        CreditCard,
        ArrowRight,
    },
    data() {
        return {
            isLoading: false,
            bannerDismissed: false,
            showCancelDialog: false,
            freshTokens: null,
            usedTokens: [],
            statusMap: {
                active: this.$t('subscription.status.active'),
                canceled: this.$t('subscription.status.canceled'),
                past_due: this.$t('subscription.status.past_due'),
                incomplete: this.$t('subscription.status.incomplete'),
                trialing: this.$t('subscription.status.trialing'),
                unpaid: this.$t('subscription.status.unpaid'),
                inactive: this.$t('subscription.status.inactive'),
            },
        }
    },
    computed: {
        subscriptionStartDate() {
            const d = (this.tenant && this.tenant.subscription_started_at) || (this.tenant && this.tenant.created_at)
            return d ? this.formatDate(d) : '-'
        },
        // Résiliation programmée : Stripe garde le statut "active" jusqu'à la fin de la
        // période payée, `ends_at` est donc le SEUL signal. Côté central il n'est écrit
        // que par SaaSWebhookController, toujours sous cancel_at_period_end ou
        // status=canceled — un ends_at futur signifie donc "résiliation en cours".
        isCanceling() {
            return !!(this.tenant && this.tenant.ends_at && new Date(this.tenant.ends_at) > new Date())
        },
        displayStatus() {
            const raw = (this.tenant && this.tenant.subscription_status) || 'inactive'
            const label = this.statusMap[raw] || raw
            if (this.isCanceling) {
                return label + ' — ' + this.$t('common.expires_at', { date: this.formatDate(this.tenant.ends_at) })
            }
            if (raw === 'canceled' && this.tenant && this.tenant.ends_at) {
                return this.$t('common.expired_at', { date: this.formatDate(this.tenant.ends_at) })
            }
            if (this.isOnTrial && this.trialEndsAt) {
                return label + ' — jusqu’au ' + this.formatDate(this.trialEndsAt)
            }
            return label
        },
        trialEndsLabel() {
            if (!this.isOnTrial || !this.trialEndsAt) return ''
            return this.formatDate(this.trialEndsAt)
        },
        showBanner() {
            if (this.bannerDismissed) return false
            const status = (this.tenant && this.tenant.subscription_status) || ''
            return ['past_due', 'unpaid', 'incomplete'].includes(status) || this.isCanceling
        },
        bannerType() {
            const status = (this.tenant && this.tenant.subscription_status) || ''
            if (['past_due', 'unpaid', 'incomplete'].includes(status)) return 'payment_failed'
            if (this.isCanceling) return 'ending'
            return 'warning'
        },
        bannerClass() {
            if (this.bannerType === 'payment_failed')
                return 'ppv2-bg-red-500/10 ppv2-border ppv2-border-red-500/30 ppv2-text-red-400'
            if (this.bannerType === 'ending')
                return 'ppv2-bg-amber-500/10 ppv2-border ppv2-border-amber-500/30 ppv2-text-amber-400'
            return 'ppv2-bg-yellow-500/10 ppv2-border ppv2-border-yellow-500/30 ppv2-text-yellow-400'
        },
        bannerTitle() {
            if (this.bannerType === 'payment_failed')
                return this.$t('subscription.banner.payment_failed_title') || 'Paiement échoué'
            if (this.bannerType === 'ending')
                return this.$t('subscription.banner.canceling_title') || 'Abonnement en cours de résiliation'
            return this.$t('subscription.banner.warning_title') || 'Attention'
        },
        bannerMessage() {
            if (this.bannerType === 'payment_failed')
                return (
                    this.$t('subscription.banner.payment_failed_message') ||
                    'Le paiement de votre abonnement a échoué. Veuillez mettre à jour votre moyen de paiement pour éviter la suspension de votre compte.'
                )
            if (this.bannerType === 'ending')
                return (
                    this.$t('subscription.banner.canceling_message', { date: this.formatDate(this.tenant.ends_at) }) ||
                    "Votre abonnement sera actif jusqu'au " +
                        this.formatDate(this.tenant.ends_at) +
                        '. Passé cette date, votre accès sera limité.'
                )
            return this.$t('subscription.banner.warning_message') || 'Une action est requise sur votre abonnement.'
        },
    },
    methods: {
        normalizeFontSize,
        normalizeSizeVertical,
        normalizeSize,
        // Decode the token's exp (base64url JSON payload before the ".") in ms, or 0.
        tokenExpiresAt(token) {
            try {
                let b64 = String(token).split('.')[0].replace(/-/g, '+').replace(/_/g, '/')
                while (b64.length % 4) b64 += '='
                const payload = JSON.parse(atob(b64))
                return payload && payload.exp ? payload.exp * 1000 : 0
            } catch (e) {
                return 0
            }
        },
        // Return a usable billing token: valid for at least 30s AND not already
        // used. Tokens are single-use server-side, so once handed out we mark it
        // and refresh from the BO endpoint on the next click (also covers expiry).
        async getValidBillingToken(name) {
            const tokens = this.freshTokens || this.billingTokens || {}
            let token = tokens[name]
            const usable = token && this.tokenExpiresAt(token) - Date.now() > 30000 && !this.usedTokens.includes(token)
            if (!usable) {
                try {
                    const { data } = await axios.get('/back-office/subscription/billing-tokens')
                    if (data && data.checkout) {
                        this.freshTokens = data
                    }
                } catch (e) {
                    // Fall back to whatever token we already have.
                }
                token = (this.freshTokens || this.billingTokens || {})[name]
            }
            if (token) {
                this.usedTokens.push(token)
            }
            return token
        },
        resolveTenantId() {
            let tenantId = this.tenantId || (this.tenant && this.tenant.id)

            if (!tenantId && typeof this.tenant === 'string' && this.tenant.startsWith('{')) {
                try {
                    const parsedTenant = JSON.parse(this.tenant)
                    tenantId = parsedTenant.id || tenantId
                } catch (e) {
                    tenantId = null
                }
            }

            if (typeof tenantId === 'string' && tenantId.startsWith('{')) {
                try {
                    const parsed = JSON.parse(tenantId)
                    tenantId = parsed.id || parsed
                } catch (e) {
                    tenantId = null
                }
            }

            return tenantId ? String(tenantId) : null
        },
        formatDate(date) {
            if (!date) return '-'
            return new Date(date).toLocaleDateString('fr-FR', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
            })
        },
        dismissBanner() {
            this.bannerDismissed = true
            try {
                localStorage.setItem('subscription_banner_dismissed', 'true')
            } catch (e) {}
        },
        async handlePortalRedirect() {
            try {
                const tenantId = this.resolveTenantId()

                if (!tenantId) {
                    this.$toast.error(this.$t('common.tenant_not_found'))
                    return
                }

                console.log('Sending portal request for tenant:', tenantId)
                this.$toast.info(this.$t('subscription.redirecting_portal'), { timeout: 2000 })

                const portalToken = await this.getValidBillingToken('portal')

                const response = await axios.post(`${this.centralDomain}/saas-subscriptions/portal`, {
                    tenant_id: tenantId,
                    billing_token: portalToken,
                    return_url: window.location.href,
                })

                if (response.data.url) {
                    window.location.href = response.data.url
                } else {
                    throw new Error('No portal URL returned')
                }
            } catch (error) {
                this.$toast.error(error.response?.data?.error || error.response?.data?.message || 'Une erreur est survenue')
            }
        },
        async handlePlanSelection(plan) {
            try {
                const tenantId = this.resolveTenantId()

                if (!tenantId) {
                    this.$toast.error(this.$t('common.tenant_not_found'))
                    return
                }

                this.isLoading = true
                console.log('Sending checkout request for plan:', plan, 'tenant:', tenantId)

                this.$toast.info(this.$t('subscription.redirecting_stripe'), { timeout: 2000 })

                const planKey = typeof plan === 'string' ? plan : plan.key
                const checkoutToken = await this.getValidBillingToken('checkout')
                const response = await axios.post(`${this.centralDomain}/saas-subscriptions/checkout`, {
                    plan_slug: planKey,
                    tenant_id: tenantId,
                    billing_token: checkoutToken,
                    success_url: window.location.origin + '/back-office/manage-subscription',
                    cancel_url: window.location.href,
                })

                if (response.data.url) {
                    window.location.href = response.data.url
                } else {
                    throw new Error('No checkout URL returned')
                }
            } catch (error) {
                this.$toast.error(error.response?.data?.error || error.response?.data?.message || 'Une erreur est survenue')
            } finally {
                this.isLoading = false
            }
        },
        goToPricing() {
            const getUrl = window.location
            const baseUrl = getUrl.protocol + '//' + getUrl.host
            window.location.href = baseUrl + '/back-office/subscription'
        },
        handleCancelSubscription() {
            if (!this.resolveTenantId()) {
                this.$toast.error(this.$t('common.tenant_not_found'))
                return
            }
            this.showCancelDialog = true
        },
        async confirmCancelSubscription() {
            this.showCancelDialog = false

            try {
                const tenantId = this.resolveTenantId()
                if (!tenantId) {
                    this.$toast.error(this.$t('common.tenant_not_found'))
                    return
                }

                this.isLoading = true
                this.$toast.info(this.$t('subscription.cancelling'), { timeout: 2000 })

                const cancelToken = await this.getValidBillingToken('cancel')

                const response = await axios.post(`${this.centralDomain}/saas-subscriptions/cancel`, {
                    tenant_id: tenantId,
                    billing_token: cancelToken,
                })

                if (response.data.success) {
                    // cancel_at peut être absent : on ne fabrique pas une date bidon (01/01/1970).
                    this.$toast.success(
                        response.data.cancel_at
                            ? this.$t('subscription.cancelled_until', {
                                  date: new Date(response.data.cancel_at * 1000).toLocaleDateString('fr-FR'),
                              })
                            : this.$t('subscription.cancelled')
                    )
                    setTimeout(() => window.location.reload(), 2000)
                } else {
                    throw new Error(response.data.error || "Échec de l'annulation")
                }
            } catch (error) {
                this.$toast.error(error.response?.data?.error || error.response?.data?.message || 'Une erreur est survenue')
            } finally {
                this.isLoading = false
            }
        },
        // Lève la résiliation programmée : rien n'est facturé, l'abonnement en cours
        // reprend son cours normal. Pas de confirmation, l'action n'est pas destructive.
        async resumeSubscription() {
            try {
                const tenantId = this.resolveTenantId()
                if (!tenantId) {
                    this.$toast.error(this.$t('common.tenant_not_found'))
                    return
                }

                this.isLoading = true

                const resumeToken = await this.getValidBillingToken('resume')

                const response = await axios.post(`${this.centralDomain}/saas-subscriptions/resume`, {
                    tenant_id: tenantId,
                    billing_token: resumeToken,
                })

                if (response.data.success) {
                    this.$toast.success(this.$t('subscription.resumed'))
                    setTimeout(() => window.location.reload(), 2000)
                } else {
                    throw new Error(response.data.error || 'Échec du rétablissement')
                }
            } catch (error) {
                this.$toast.error(error.response?.data?.error || error.response?.data?.message || 'Une erreur est survenue')
            } finally {
                this.isLoading = false
            }
        },
        handleScroll() {
            const threshold = 200
            const isBeyondThreshold = window.scrollY > threshold

            if (isBeyondThreshold) {
                document.body.classList.add('pp-sticky-page')
                document.documentElement.classList.add('pp-sticky-page')
            } else {
                document.body.classList.remove('pp-sticky-page')
                document.documentElement.classList.remove('pp-sticky-page')
            }
        },
    },
    mounted() {
        try {
            if (localStorage.getItem('subscription_banner_dismissed') === 'true') {
                this.bannerDismissed = true
            }
        } catch (e) {}
        window.addEventListener('scroll', this.handleScroll)
        this.handleScroll()
        const mainContainer = document.getElementById('main-container')
        if (mainContainer) {
            mainContainer.classList.add('subscription-v3-no-bg')
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
        document.body.classList.remove('pp-sticky-page')
        document.documentElement.classList.remove('pp-sticky-page')
    },
}
</script>

<style scoped lang="scss">
.suscription-v3-container {
    padding: 0;
}
.ppv2-overflow-visible {
    overflow: visible !important;
}
</style>

<style>
/* Global overrides for sticky functionality on this page only */
html.pp-sticky-page,
body.pp-sticky-page,
.pp-sticky-page #page-container,
.pp-sticky-page #main-container,
.pp-sticky-page .v-application--wrap {
    overflow: visible !important;
    height: auto !important;
    min-height: 100vh;
}

#main-container:has(.subscription-v3-container) {
    background: transparent !important;
}
.dark #main-container.subscription-v3-no-bg,
.dark #main-container:has(.subscription-v3-container) {
    background: transparent !important;
}
#main-container.subscription-v3-no-bg {
    background: transparent !important;
    border-radius: 0px;
}
@media screen and (max-width: 767px) {
    .cardManagement {
        gap: 25px !important;
    }
}
</style>
